import { axios } from '@Root/API'

export const search = payload => {
  return axios.get('advanced-search', { params: { ...payload } })
}
